import { calculateTcyValue } from 'further-ui/utils';

import { CurrencyRateDetails } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { ConsiderationTypeHoldingClassTypes } from 'further-types/lp/realisation';

// Helper function to handle currency conversion when LCY is the base currency
const applyLcyBasedCurrencyLogic = (
  amountTcy: number,
  transactionCurrencyRate: CurrencyRateDetails | null,
  realisationType: ConsiderationTypeHoldingClassTypes,
  holdingClassCurrency: CurrencyCode,
  realisationCurrency: CurrencyCode,
) => {
  const isLcyConsiderationForNonLcy =
    realisationType ===
    ConsiderationTypeHoldingClassTypes.LcyConsiderationForNonLcyHoldingClass;

  return {
    amountExVatTcy: isLcyConsiderationForNonLcy
      ? calculateTcyValue(amountTcy, transactionCurrencyRate)
      : amountTcy,
    amountIncVatTcy: isLcyConsiderationForNonLcy
      ? calculateTcyValue(amountTcy, transactionCurrencyRate)
      : amountTcy,
    amountExVatLcy: isLcyConsiderationForNonLcy ? amountTcy : undefined,
    amountIncVatLcy: isLcyConsiderationForNonLcy ? amountTcy : undefined,
    preCalculatedAmounts: isLcyConsiderationForNonLcy,
    transactionCurrencyRate: transactionCurrencyRate ?? undefined,

    transactionCurrency: isLcyConsiderationForNonLcy
      ? holdingClassCurrency
      : realisationCurrency,
  };
};

export default applyLcyBasedCurrencyLogic;
